// extracted by mini-css-extract-plugin
export default {"eachAccountWrapper":"SpaEachSuggestedResult_eachAccountWrapper__u22ch","companyName":"SpaEachSuggestedResult_companyName__qIcg9"};